import React,{createContext,useContext,useEffect,useRef,useState} from 'react';
import {useAuth} from '../../context/AuthContext';
import api from '../../services/api';
import {stopAssistantPlayback} from './AssistantPlayback';
export {AssistantChat,AssistantWidget} from './GasChat';
const Context=createContext(null);
export const useAssistant=()=>useContext(Context);
const base='/ai/assistant';
export function AssistantProvider({children}) {
  const {user,tenant}=useAuth(),admin=user?.ruolo==='admin';
  const [open,setOpen]=useState(false),[id,setId]=useState(''),[items,setItems]=useState([]),[messages,setMessages]=useState([]),[question,setQuestion]=useState(''),[busy,setBusy]=useState(false),[error,setError]=useState(''),[coverage,setCoverage]=useState(null);
  const selected=useRef(''),identity=useRef('');
  const identityKey=String(tenant?.id||tenant?.slug||'')+':'+String(user?.id||'');
  const [ownerKey,setOwnerKey]=useState(identityKey);
  identity.current=identityKey;
  const refresh=async()=>{
    if(!admin)return;
    const owner=identity.current;
    try{const [a,b]=await Promise.all([api.get(base+'/conversations'),api.get(base+'/index')]);if(identity.current!==owner)return;setItems(a.data);setCoverage(b.data);}
    catch(err){if(identity.current===owner)setError(err.response?.data?.error||'Assistente non disponibile.');}
  };
  const load=async nextId=>{
    const owner=identity.current;
    selected.current=nextId;setId(nextId);setQuestion('');setMessages([]);setError('');
    if(!nextId)return;
    try{const r=await api.get(base+'/conversations/'+nextId);if(identity.current===owner&&selected.current===nextId)setMessages(r.data.messages);}
    catch(err){if(identity.current===owner&&selected.current===nextId)setError(err.response?.data?.error||'Conversazione non disponibile.');}
  };
  useEffect(()=>{
    selected.current='';setOwnerKey(identityKey);setId('');setMessages([]);setItems([]);setQuestion('');setOpen(false);setBusy(false);setError('');setCoverage(null);
    return()=>stopAssistantPlayback();
  },[identityKey]);
  // Refresh only on opening; changing conversation state must not trigger another fetch.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(()=>{if(open)refresh();},[open]);
  useEffect(()=>{
    if(!id || !messages.some(m=>m.status==='processing'))return undefined;
    const owner=identity.current;
    const timer=setInterval(async()=>{try{const r=await api.get(base+'/conversations/'+id);if(identity.current===owner&&selected.current===id)setMessages(r.data.messages);}catch(_){}},2000);
    return()=>clearInterval(timer);
  },[id,messages]);
  const send=async(context)=>{
    if(!question.trim() || busy || messages.some(m=>m.status==='processing') || !admin || ownerKey!==identityKey)return;
    const text=question.trim(),owner=identity.current;setBusy(true);setError('');
    let nextId=selected.current;
    try{
      if(!nextId){const r=await api.post(base+'/conversations');nextId=r.data.id;if(identity.current!==owner)return;selected.current=nextId;setId(nextId);}
      const requestId=crypto.randomUUID();
      setMessages(old=>[...old,{id:requestId,question:text,status:'processing'}]);setQuestion('');
      const r=await api.post(base+'/conversations/'+nextId+'/messages',{requestId,question:text,context},{timeout:100000});
      if(identity.current===owner && selected.current===nextId)setMessages(old=>old.map(m=>m.id===requestId?r.data.message:m));
      if(identity.current===owner)refresh();
    }catch(err){if(identity.current===owner){setError(err.response?.data?.error||'Risposta non ricevuta: controlla la cronologia prima di riprovare.');if(nextId)load(nextId);else setQuestion(text);}}
    finally{if(identity.current===owner)setBusy(false);}
  };
  const remove=async(nextId=id)=>{if(!nextId)return;const owner=identity.current;try{await api.delete(base+'/conversations/'+nextId);if(identity.current!==owner)return;if(selected.current===nextId)await load('');await refresh();}catch(_){if(identity.current===owner)setError('Cancellazione non riuscita. Riprova.');}};
  const current=ownerKey===identityKey;
  return <Context.Provider value={{identityKey,admin,open:current&&open,setOpen,id:current?id:'',items:current?items:[],messages:current?messages:[],question:current?question:'',setQuestion,busy:current&&(busy||messages.some(m=>m.status==='processing')),error:current?error:'',coverage:current?coverage:null,refresh,load,send,remove}}>{children}</Context.Provider>;
}
